import styled from "styled-components";
import { COLORS } from "../../../../constants/Styles";

export const ShipmentsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
`;

export const ShipmentsRow = styled.div`
  display: flex;
  gap: 0.5rem 2rem;
  align-items: flex-end;
  flex-wrap: wrap;
`;

export const ShipmentsRowContainer = styled.div`
  display: flex;
  gap: 0.5rem 2rem;
  align-items: center;
  flex-wrap: wrap;
  justify-content: stretch;
  background-color: ${COLORS.inputGray};
  border-radius: 1rem;
  padding: 0.5rem 0.75rem 0.5rem 0.75rem;
`;

export const ShipmentsColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ShipmentActionContainer = styled.div`
  width: 4rem;
`;

export const ShipDate = styled.div`
  min-width: 6rem;
  align-self: stretch;
  display: flex;
  flex-direction: column;
`;

export const LoadingPill = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  height: 1rem;
`;

export const Remove = styled.div`
  min-width: 6rem;
  padding-bottom: 0.5rem;
  display: flex;
  align-items: flex-end;
  align-self: stretch;
`;

export const PickUpInfo = styled.div`
  display: flex;
  gap: 0.25rem;
  flex-direction: column;
  color: ${COLORS.altSecondary};
`;

export const ShipmentDetail = styled.div`
  display: flex;
  flex-direction: column;
  width: 8rem;
`;
